import { useCallback, useMemo, useState } from 'react';
import MgoToast from '@humanforce/mango-ui/dist/react/toast/index.js';
import MgoToastStack from '@humanforce/mango-ui/dist/react/toast-stack/index.js';
import { asMangoElement } from './mango';

const MangoToast = asMangoElement(MgoToast);
const MangoToastStack = asMangoElement(MgoToastStack);

interface ToastMessage {
  id: number;
  message: string;
  tone: 'positive' | 'critical' | 'caution' | 'neutral';
}

export const useToast = () => {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  const addToast = useCallback((message: string, tone: ToastMessage['tone'] = 'positive') => {
    const id = Date.now();
    setToasts((current) => [...current, { id, message, tone }]);
  }, []);

  const removeToast = useCallback((id: number) => {
    setToasts((current) => current.filter((toast) => toast.id !== id));
  }, []);

  return useMemo(() => ({ addToast, removeToast, toasts }), [addToast, removeToast, toasts]);
}

interface ToastContainerProps {
  toasts: ToastMessage[];
  onClose: (id: number) => void;
}

export const ToastContainer = ({ onClose, toasts }: ToastContainerProps) => {
  return (
    <MangoToastStack>
      {toasts.map((toast) => (
        <MangoToast key={toast.id} open tone={toast.tone} onMgoClose={() => onClose(toast.id)}>
          {toast.message}
        </MangoToast>
      ))}
    </MangoToastStack>
  );
}
